import Http from '@rrc-materials/http'
import HttpConfig from '@/config/http.config'

Http.use(HttpConfig)

const BASEURL = process.env.NODE_ENV === 'development' ? '/api' : ''

const http = new Http({
  baseURL: BASEURL,
  axios: {
    timeout: 20000,
    withCredentials: true,
    xsrfCookieName: 'axios-inspector-m-csrftoken', // default: XSRF-TOKEN
  }
})

export default http
